import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useDispatch, useSelector } from "react-redux";

import { alertActions, breadcrumbsActions, userProjectsActions as myActions, masterProfilesActions } from "../../../_services/essentials/store";

import Grid from "@mui/material/Grid2";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Pagination from '@mui/material/Pagination';
import { history } from "../../../_services/essentials/helpers";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import { IconButton, Link, Avatar, TextField, FormControl, Tooltip, } from '@mui/material';
import CircleRoundedIcon from '@mui/icons-material/CircleRounded';
import AddIcon from '@mui/icons-material/Add';

import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import PropTypes from "prop-types";
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import { Tab, Tabs } from "@mui/material";
// import OutlinedInput from "@mui/material/OutlinedInput";
// import InputAdornment from "@mui/material/InputAdornment";
// import Search from '_components/common/Search';
import CircularProgress from '@mui/material/CircularProgress';
import moment from 'moment';
import {NoRecordsFound} from "../../../_components/NoRecordsFound";
export { List };

function List() {
    //    const entity_name = "project";
    //    const entity_label = "Project";
    //    const entities_name = "projects";
    const entities_label = "Projects";

    const loggedInUser = useSelector(x => x.auth.loggedInUser);
    const listAPIResponse = useSelector(x => x.userProjects?.listAPIResponse);

    const [loading, setLoading] = useState(true);
    const [entities, setEntities] = useState([]);
    const [totalPages, setTotalPages] = useState('');
    const [totalItems, setTotalItems] = useState('');
    const [onLoadWait, setOnLoadWait] = useState(true);

    useEffect(() => {
        if (
            listAPIResponse &&
            listAPIResponse.value &&
            Array.isArray(listAPIResponse.value.list)) {
            setEntities(listAPIResponse?.value?.list);
            setTotalPages(listAPIResponse?.value?.totalPages);
            setTotalItems(listAPIResponse?.value?.totalItems);

            setLoading(false);
        }
    }, [listAPIResponse]);

    const dispatch = useDispatch();

    const validationSchema = Yup.object().shape({
        name: Yup.string()
            .trim()
            .required('Required*')
            .max(60, 'Cannot exceed 60 characters'),
        description: Yup.string()
            .trim()
            .required('Required*')
            .max(250, 'Cannot exceed 250 characters'),
        geographicScope: Yup.string()
            .trim()
            .required('Required*')
            .max(60, 'Cannot exceed 60 characters'),
        keywordOrTherapeuticArea: Yup.string()
            .trim()
            .required('Required*')
            .max(60, 'Cannot exceed 60 characters'),
    });

    const formOptions = { resolver: yupResolver(validationSchema) };

    //const { register, handleSubmit, reset, formState, control } = useForm(formOptions);
    const { register, handleSubmit, reset, formState } = useForm(formOptions);

    const { errors } = formState;
    const apiServerURL = `${process.env.REACT_APP_API_URL}`;

    const [dataFilter, setDataFilter] = useState({
        "userProjectFilter": {
            activeStatusGroupFlag: true,
            userId: loggedInUser?.id,
            searchTerms: ""
        }
    });

    const [pageFilter, setPageFilter] = useState({
        "pageNumber": 1,
        "pageSize": 100000,
        "sortField": "status.sortOrder, lastUpdatedTime",
        "sortDirection": "asc, desc",
        "dataFilter": dataFilter
    });
    const [openCreateProjectPopup, setOpenCreateProjectPopup] = useState(false);

    const memoizedPageFilter = useMemo(() => {
        return {
            ...pageFilter,
            dataFilter: {
                ...dataFilter,
            },
        };
    }, [dataFilter]);

    dispatch(breadcrumbsActions.setCurrentURL({
        url: history.location?.pathname,
        state: history.location?.state
    }));

    useEffect(() => {
        setDataFilter({
            "userProjectFilter": {
                activeStatusGroupFlag: true,
                userId: loggedInUser?.id,
                searchTerms: ""
            }
        });
    }, [loggedInUser]);

    useEffect(() => {
        if(!onLoadWait) {
            dispatch(breadcrumbsActions.setCurrentTitle(entities_label));
            dispatch(myActions.getPaginatedList(memoizedPageFilter));
        }
    }, [pageFilter, onLoadWait ]);

    useEffect(() => {
        if(!onLoadWait) {
            dispatch(breadcrumbsActions.setCurrentTitle(entities_label));
            dispatch(myActions.getPaginatedList(memoizedPageFilter));
        }
    }, [pageFilter, onLoadWait ]);

    useEffect(() => {
        if(onLoadWait){
            const timeoutId = setTimeout(() => {
                setOnLoadWait(false);
            }, 100);

            return () => clearTimeout(timeoutId);
        }
    }, [onLoadWait]);

    function navigatePage(event, newPageNumber) {
        setPageFilter({
            ...pageFilter,
            "pageNumber": newPageNumber
        });
    }

    function showProjectProfiles(selectedUserProject) {
        //history.navigate(`/master_profiles?project_id=${selectedProjectId}`);
        history.navigate(`/master_profiles?user_projects=true`, { state: { selectedUserProject } });

    }
    function handleCreateProjectPopupClose() {
        setOpenCreateProjectPopup(false);
    }

    function CustomTabPanel(props) {
        const { children, value, backgroundColor, index, ...other } = props;

        return (
            <Box
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                minHeight={'200px'}
                sx={{ flexDirection: 'row', mb: 3 }}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index &&
                    <Stack direction="column" sx={{
                        justifyContent: 'center',
                        alignItems: 'center'
                        // background: backgroundColor,
                        // border: '0px solid #0052eb',
                        // borderColor: '#777',
                        // backdropFilter: 'blur(1px)',
                        // borderRadius: '12px'

                    }}>
                        {children}
                    </Stack>
                }
            </Box>
        );
    }

    CustomTabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }
    async function downloadprofiles(event, projectId, projectName) {
        const dataFilter = {
            "masterProfileFilter": {
                projectId: projectId,
                userId: loggedInUser?.id,
                searchTerms: ""
            }
        };
        const pageFilter = {
            "pageNumber": 1,
            "pageSize": 100000, //TODO: Move this to env
            "sortField": "ranking",
            "sortDirection": "asc",
            "dataFilter": dataFilter,
            "projectName": projectName
        };

        await dispatch(masterProfilesActions.downloadprofilesByFilter(pageFilter)).unwrap();
        dispatch(myActions.getAll());
    }

    const containerRef = useRef(null);
    const [gridSpacing, setGridSpacing] = useState(2);
    const CreateProjectPopupStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 526,
        bgcolor: 'background.modal',
        // border: '2px solid #000',
        boxShadow: 24,
        borderRadius: '10px'
    };
    async function handleCreateProjectPopupOpen() {
        const newProjectEntity = {
            user: loggedInUser,
            name: "",
            description: "",
            commentAndQuestion: "",
            geographicScope: "",
            communicationMode: { "id": 1 },
            keywordOrTherapeuticArea: "",
            // privacyPolicyAcknowledgement: false,
            type: { "id": 1 },
            status: { "id": 1 }
        };
        await dispatch(myActions.getNewEntity(newProjectEntity)).unwrap();
        setOpenCreateProjectPopup(true);
    }

    async function handleCreateProjectAndAddProfiles(data) {
        const response = await dispatch(myActions.create({ data })).unwrap();
        const message = response ? response.message : '';

        if (message !== '')
            await dispatch(alertActions.success({ message, showAfterRedirect: false }));

        setOpenCreateProjectPopup(false);
        reset();
        setPageFilter({
            ...pageFilter,
            pageNumber: 1
        }
        );
        setLoading(true);

    }
    useEffect(() => {
        const container = containerRef.current;

        if (container) {
            const observer = new ResizeObserver((entries) => {
                for (let entry of entries) {
                    const { width } = entry.contentRect;
                    if (width >= 1350) {
                        setGridSpacing(2);
                    } else if (width >= 1200) {
                        setGridSpacing(6.5);
                    } else {
                        setGridSpacing(6);
                    }
                }
            });

            observer.observe(container);

            return () => observer.disconnect();
        }
    }, []);

    return (
        <Box sx={{ width: '99%', maxWidth: { sm: '100%', md: '100%' }, ml: 2 }} ref={containerRef}>
            {/* <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
                {entities_label}
            </Typography> */}
            <Stack direction="row"
                sx={{ width: '100%', justifyContent: 'space-between', flexGrow: '1', gap: 1, pt: 2, pb: 2, mb: 2, border: '1px solid #E0E0E066' }} spacing={3}>
                {/* <Stack sx={{ pl: 4, width: '100%' }}>
                    <Search control={control} sx={{ width: '350px' }} handleSubmit={handleSubmit}

                    />
                </Stack> */}
                <Stack direction="row" spacing={2} sx={{ mb: 1, mt: 0.5, width: '100%', justifyContent: 'right' }} >

                    <Button onClick={() => handleCreateProjectPopupOpen()}
                        variant="contained" color="primary" size="small"
                        endIcon={<AddIcon />}>
                        Create Project
                    </Button>
                    <Stack direction="row" sx={{ ml: 8, justifyContent: 'center', alignItems: 'center' }}>
                        <Avatar
                            sx={{
                                height: 24,
                                backgroundColor: '#666fff',
                                color: '#FFF',
                                fontSize: '13px', fontWeight: 600
                            }}
                        >
                            {totalItems ? totalItems.toLocaleString() : 0}
                        </Avatar>
                        <Typography variant="body1" sx={{ ml: 0.5, mr: 1, fontWeight: 600 }}> Projects
                        </Typography>
                    </Stack>

                    <Modal
                        aria-labelledby="transition-modal-title"
                        aria-describedby="transition-modal-description"
                        open={openCreateProjectPopup}
                        onClose={handleCreateProjectPopupClose}
                        closeAfterTransition
                        slots={{ backdrop: Backdrop }}
                        slotProps={{
                            backdrop: {
                                timeout: 500,
                            },
                        }}
                    >
                        <Fade in={openCreateProjectPopup}>
                            <Box sx={CreateProjectPopupStyle}>
                                <Box sx={{}}>
                                    <Tabs
                                        value={0}

                                        indicatorColor="none"
                                        textColor="primary"
                                        sx={{
                                            ".MuiTabs-indicator": {
                                                display: "none",
                                            },

                                        }}
                                    >
                                        <Tab label="Create New Project" {...a11yProps(0)} sx={{
                                            minWidth: '100%', fontSize: '18px',
                                            fontWeight: 'bold',
                                            minHeight: 69,
                                            // background: '#efe2ba',
                                            // backdropFilter: 'blur(1px)',
                                            // borderTopLeftRadius: '12px',
                                            // borderTopRightRadius: '0px',
                                            // borderBottomRightRadius: '0px'
                                        }} />

                                    </Tabs>
                                </Box>
                                <CustomTabPanel value={0} index={0}>
                                    {!(entities?.loading || entities?.error) &&
                                        <form name="newProjectForm" id="newProjectForm" onSubmit={handleSubmit(handleCreateProjectAndAddProfiles)}>
                                            <Stack direction="column" sx={{ flexGrow: '1', gap: 1, mt: 2 }} >
                                                <Stack direction="column">
                                                    <TextField id="user" name="user" hidden type="text" value={loggedInUser?.id} {...register('user.id')} />
                                                    <TextField id="communicationMode" name="communicationMode" hidden type="text" value={1} {...register('communicationMode.id')} />
                                                    <TextField id="type" name="type" hidden type="text" value={1} {...register('type.id')} />
                                                    <TextField id="status" name="status" hidden type="text" value={1} {...register('status.id')} />
                                                    <TextField
                                                        id="commentAndQuestion"
                                                        name="commentAndQuestion"
                                                        type="text"
                                                        variant='outlined'
                                                        color='primary'
                                                        hidden
                                                        label="Additional Comments or Questions"
                                                        placeholder={""}
                                                        inputlabelprops={{ shrink: true }}
                                                        defaultValue={""}
                                                        {...register('commentAndQuestion')}
                                                    />
                                                    <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >
                                                        <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>
                                                            Project Name<span style={{ color: 'red' }}>*</span></Typography>
                                                    </Stack>
                                                    <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >
                                                        <TextField
                                                            id="name"
                                                            name="name"
                                                            type="text"
                                                            variant='outlined'
                                                            color='primary'
                                                            placeholder={"Project Name"}
                                                            fullWidth

                                                            sx={{ mb: 1 }}
                                                            inputlabelprops={{ shrink: true }}
                                                            defaultValue={""}
                                                            {...register('name')}
                                                            error={Boolean(errors.name)}
                                                            inputProps={{
                                                                maxLength: 60,
                                                            }}
                                                            helperText={errors.name ? errors.name.message : ""}
                                                        />
                                                    </Stack>
                                                    <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >
                                                        <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>
                                                            Project Description<span style={{ color: 'red' }}>*</span></Typography>
                                                    </Stack>
                                                    <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >
                                                        <TextField
                                                            id="description"
                                                            name="description"
                                                            type="text"
                                                            variant='outlined'
                                                            color='primary'
                                                            placeholder={"Project Description"}
                                                            fullWidth
                                                            multiline
                                                            size="normal"
                                                            rows={3}
                                                            sx={{
                                                                mb: 1,
                                                                '& .MuiInputBase-root': {
                                                                    height: 'auto',
                                                                    maxWidth: '95%'
                                                                },
                                                            }}
                                                            inputlabelprops={{ shrink: true }}
                                                            defaultValue={""}
                                                            {...register('description')}
                                                            inputProps={{
                                                                maxLength: 250,
                                                            }}
                                                            error={Boolean(errors.description)}
                                                            helperText={errors.description ? errors.description.message : ""}
                                                        />
                                                    </Stack>

                                                    <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >
                                                        <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>
                                                            Keyword / Therapeutic Area / Specialty<span style={{ color: 'red' }}>*</span></Typography>
                                                    </Stack>
                                                    <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >

                                                        <TextField
                                                            id="keywordOrTherapeuticArea"
                                                            name="keywordOrTherapeuticArea"
                                                            type="text"
                                                            variant='outlined'
                                                            color='primary'
                                                            fullWidth
                                                            // label="Keyword or Therapeutic Area"
                                                            sx={{ mb: 1 }}
                                                            placeholder={"Keyword / Therapeutic Area / Specialty"}
                                                            inputlabelprops={{ shrink: true }}
                                                            defaultValue={""}
                                                            {...register('keywordOrTherapeuticArea')}
                                                            error={Boolean(errors.keywordOrTherapeuticArea)}
                                                            inputProps={{
                                                                maxLength: 60,
                                                            }}
                                                            helperText={errors.keywordOrTherapeuticArea ? errors.keywordOrTherapeuticArea.message : ""}
                                                        />
                                                    </Stack>
                                                    <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >
                                                        <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>
                                                            Geographic Scope  <span style={{ color: 'red' }}>*</span></Typography>
                                                    </Stack>
                                                    <Stack direction="row" sx={{ flexGrow: '1' }} >

                                                        <TextField
                                                            id="geographicScope"
                                                            name="geographicScope"
                                                            type="text"
                                                            variant='outlined'
                                                            color='primary'
                                                            // label="Geographic Scope"
                                                            sx={{ mb: 1 }}
                                                            fullWidth
                                                            placeholder={"Geographic Scope"}
                                                            inputlabelprops={{ shrink: true }}
                                                            defaultValue={""}
                                                            {...register('geographicScope')}
                                                            error={Boolean(errors.geographicScope)}
                                                            helperText={errors.geographicScope ? errors.geographicScope.message : ""}
                                                            inputProps={{
                                                                maxLength: 60,
                                                            }}
                                                        />
                                                    </Stack>
                                                    <FormControl>

                                                        <Stack direction="row" spacing={2} sx={{ justifyContent: 'space-between', mt: 0.5, px: 3 }} >
                                                            <Button type={"submit"} variant="contained" color="primary" size="small"
                                                                sx={{ fontSize: 16, fontWeight: 600 }}
                                                            >
                                                                Create
                                                            </Button>
                                                            <Button onClick={() => reset()} variant="outlined" size="small"
                                                                sx={{ backgroundColor: 'buttonVar.reset', color: 'buttonVar.resetText', fontSize: 16, fontWeight: 600 }}
                                                            >
                                                                Reset
                                                            </Button>
                                                            <Button onClick={() => handleCreateProjectPopupClose()} variant="outlined"
                                                                size="small" sx={{ backgroundColor: 'buttonVar.cancel', fontSize: 16, fontWeight: 600 }}  >
                                                                Cancel
                                                            </Button>
                                                        </Stack>
                                                    </FormControl>
                                                </Stack>
                                            </Stack>
                                        </form>
                                    }
                                </CustomTabPanel>

                            </Box>
                        </Fade>
                    </Modal>
                </Stack>
            </Stack>
            {loading ? (<div
                style={{
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    height: '80%'
                    // zIndex: 1,
                }}
            >
                <CircularProgress />
            </div>) : (
                <Grid container spacing={1} columns={12}>
                    <Grid size={{ md: 12, lg: 12 }}>
                        <Grid
                            container
                            spacing={2}
                            columnSpacing={gridSpacing}
                            rowSpacing={3}
                            columns={12}
                            sx={{ mb: (theme) => theme.spacing(1) }}
                        >
                            {(entities?.length > 0) && entities?.map((entity, index) => (
                                <Grid key={index} item
                                    //  size={{ xs: 6, sm: 6, lg: 6 }}
                                      sx={{
                                          flexBasis: '250px',
                                          flexGrow: 0,
                                      }}>
                                    <Card
                                        variant="outlined" sx={{
                                        // height: '100%',
                                        //  flexGrow: 0.5,
                                        // background: 'linear-gradient(to top, #9cb0f2, #d5e2ed 200px)',
                                        // background: 'linear-gradient(to top, #d5e2ed, #9cb0f2 200px)',
                                        border: '1px solid rgba(79, 70, 229, 0.20)',
                                        backdropFilter: 'blur(1px)',
                                        borderRadius: '15px',
                                        p: 0,
                                        transition: "transform .3s ease, box-shadow .3s ease",
                                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                        "&:hover": {
                                            transform: "translateY(-2px)",
                                            boxShadow: "0px 8px 8px rgba(0, 0, 0, 0.3)",
                                            "& .corner-value": {
                                                visibility: 'visible',
                                                opacity: 1,
                                            }
                                        },

                                        // opacity: (entity.status?.isActive === 0) ? 0.6 : 1,
                                    }}
                                    >
                                        <Tooltip title={entity.totalProfilesAdded === 0 ? "No KOL found" : null}>
                                            <Box sx={{
                                                pointerEvents: (entity.status?.isActive === 0 || entity.totalProfilesAdded === 0) ? 'none' : 'auto',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            }}
                                                 onClick={() => showProjectProfiles(entity)}>
                                                <img
                                                    src={`${apiServerURL}/resources/assets/images/projects/${(entity.id % 8) + 1}.png`}
                                                    alt="Project" loading="lazy"
                                                    className="app-user-projects-logo"
                                                    style={{}}
                                                    // style={{ height: '128px', width: '100%' }}
                                                />
                                                {/* {(Date(entity.lastUpdatedTime).toLocaleString()
                                                        .toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" })).substring(0, 25)} */}

                                                {/*className="app-user-projects-logo"*/}
                                                {/*/resources/assets/images/projects/1.png*/}
                                            </Box>

                                            <Stack direction="row" sx={{
                                                flexGrow: '1', gap: 1,
                                                backgroundColor: (entity.status?.isActive === 0) ? 'grey.500' : 'background.paper',
                                                mb: 1
                                            }}>
                                                <Box
                                                    sx={{
                                                        cursor: 'pointer', width: '100%',
                                                        pointerEvents: (entity.status?.isActive === 0 || entity.totalProfilesAdded === 0) ? 'none' : 'auto'
                                                    }}
                                                    onClick={() => showProjectProfiles(entity)}>
                                                    <Typography
                                                        // component="h2" variant="subtitle1" gutterBottom>
                                                        variant="body1" component="div" sx={{
                                                        fontWeight: '600',
                                                        // m: 2,
                                                        mt: 1,
                                                        mb: 1,
                                                        ml: 2,
                                                        mr: 2,
                                                        color: '#FFF'
                                                    }}>
                                                        {entity?.name?.length > 0 ? (entity.name.slice(0, 20) + (entity.name.length > 20 ? "..." : ""))  : ''}
                                                    </Typography>

                                                    {/* {entity.totalProfilesAdded === 0 && <Tooltip title="No KOL found">} */}
                                                    {/* <Stack
                                                direction="column"
                                                sx={{ flexGrow: '1', gap: 1 }}
                                            > */}
                                                </Box>
                                            </Stack>
                                        </Tooltip>
                                        <CardContent>

                                            <Tooltip title={entity.totalProfilesAdded === 0 ? "No KOL found" : null}>
                                                <Box sx={{
                                                    pl: 2,
                                                    pr: 2,
                                                    cursor: 'pointer',
                                                    pointerEvents: (entity.status?.isActive === 0 || entity.totalProfilesAdded === 0) ? 'none' : 'auto',
                                                }}
                                                 onClick={() => showProjectProfiles(entity)}>
                                                    <Stack direction={'column'}>
                                                        <Typography sx={{ fontSize: '12px', mt:1, color: 'grey' }}>
                                                            KOL Added:
                                                        </Typography>
                                                        <Typography variant="subtitle2" sx={{ color: 'primary' }}>
                                                            {entity?.totalProfilesAdded? entity?.totalProfilesAdded  : 0}
                                                        </Typography>
                                                    </Stack>
                                                    <Stack direction={'column'}>
                                                        <Typography sx={{ fontSize: '12px', mt:1, color: 'grey' }}>
                                                            Project Description:
                                                        </Typography>
                                                        <Typography variant="subtitle2" sx={{ color: 'primary' }}>
                                                            {entity?.description?.length > 0 ? (entity.description.slice(0, 25) + (entity.description.length > 25 ? "..." : ""))  : 'N/A'}
                                                        </Typography>
                                                    </Stack>
                                                    <Stack direction={'column'}>
                                                        <Typography sx={{ fontSize: '12px', mt:1, color: 'grey' }}>
                                                            Service Provided:
                                                        </Typography>
                                                        <Typography variant="subtitle2" sx={{ color: 'primary' }}>
                                                            {entity.type ? entity.type?.name : 'N/A'}
                                                        </Typography>
                                                    </Stack>
                                                    <Stack direction={'column'}>
                                                        <Typography sx={{ fontSize: '12px', mt:1, color: 'grey' }}>
                                                            Specialty:
                                                        </Typography>
                                                        <Typography variant="subtitle2" sx={{ color: 'primary' }}>
                                                            {entity?.keywordOrTherapeuticArea?.length > 0 ? (entity.keywordOrTherapeuticArea.slice(0, 25) + (entity.keywordOrTherapeuticArea.length > 25 ? "..." : ""))  : 'N/A'}
                                                        </Typography>
                                                    </Stack>
                                                    <Stack direction={'column'}>
                                                        <Typography sx={{ fontSize: '12px', mt:1, color: 'grey' }}>
                                                            Geography:
                                                        </Typography>
                                                        <Typography variant="subtitle2" sx={{ color: 'primary' }}>
                                                            {entity.geographicScope ? entity.geographicScope : 'N/A'}
                                                        </Typography>
                                                    </Stack>
                                                    <Stack direction="row" sx={{pb: 1, borderBottom: '1px solid grey'}}></Stack>
                                                </Box>
                                            </Tooltip>
                                            <Stack direction="row" sx={{
                                                pl: 2, pr: 2, flexGrow: '1',
                                                justifyContent: 'space-between',
                                            }}>
                                                <Stack
                                                    direction="row"
                                                    sx={{pointerEvents: 'auto'}}>
                                                    <Link
                                                        // onClick={() => showProjectProfiles(entity)}
                                                        onClick={() =>
                                                            history.navigate(`/user_projects/edit/${entity.id}`)
                                                        }
                                                        variant="body2"
                                                        sx={{
                                                            alignSelf: 'center', cursor: 'pointer',
                                                            textDecoration: "none",
                                                            color: 'background.paper'
                                                        }}
                                                    >
                                                        Edit Project
                                                        <ArrowCircleRightOutlinedIcon
                                                            sx={{color: 'background.paper', ml: 1}}/>
                                                    </Link>
                                                </Stack>
                                                <Tooltip
                                                    title={entity.totalProfilesAdded === 0 ? "No KOL found" : null}>
                                                    <Stack
                                                        direction="row" sx={{}}>
                                                        <IconButton
                                                            color="inherit"
                                                            sx={{
                                                                border: "none",
                                                                pointerEvents: (entity.status?.isActive === 0 || entity.totalProfilesAdded === 0) ? 'none' : 'auto',
                                                            }}
                                                            onClick={(e) => {
                                                                downloadprofiles(e, entity.id, entity.name)
                                                            }}
                                                        >
                                                            <FileDownloadOutlinedIcon
                                                                sx={{color: (entity.status?.isActive === 0 || entity.totalProfilesAdded === 0) ? 'grey.500' : '#4F46E5'}}/></IconButton>
                                                    </Stack>
                                                </Tooltip>
                                            </Stack>
                                            <Stack direction="row" sx={{
                                                backgroundColor: '#c4d4f1',
                                                //border: 1,
                                                //mt: 0.5,
                                                height: '30px'
                                            }}>
                                                <Box
                                                    sx={{
                                                        position: 'absolute',
                                                        bottom: 4,
                                                        left: 20,
                                                        color: (entity.status.id === 1) ? "#008000" : (entity.status.id === 5) ? "#808b96" : "#0c87be",
                                                        fontSize: '10px',
                                                        height: '20px',
                                                        transition: 'visibility 0s, opacity 0.2s ease-in-out',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    {/*<Badge*/}
                                                    {/*    color="secondary"*/}
                                                    {/*    variant="dot"*/}
                                                    {/*    overlap="circular"*/}
                                                    {/*    sx={{*/}
                                                    {/*        pt: .5,*/}
                                                    {/*        '.MuiBadge-dot': {*/}
                                                    {/*            boxShadow: `0 0 10px rgba(220, 0, 78, 0.8)`,*/}
                                                    {/*            animation: 'glow-animation .5s infinite alternate',*/}
                                                    {/*            color: "#ff0000"*/}
                                                    {/*        },*/}
                                                    {/*    }}*/}
                                                    {/*>  </Badge>*/}
                                                    <CircleRoundedIcon sx={{mb: 0.5, fontSize: '10px'}}/>
                                                    <span style={{
                                                        paddingLeft: '4px',
                                                        paddingTop: '4px',
                                                        fontSize: '12px',
                                                        mt: .5
                                                    }}>{entity.status?.name} </span>
                                                </Box>
                                                <Box
                                                    sx={{
                                                        position: 'absolute',
                                                        bottom: 4,
                                                        right: 2,
                                                        mr:1,
                                                        mt: .5,
                                                        //color: 'background.paper',
                                                        fontSize: '10px',
                                                        height: '20px',
                                                        // visibility: 'hidden',
                                                        // opacity: 0,
                                                        // transition: 'visibility 0s, opacity 0.2s ease-in-out',
                                                        zIndex: 1,
                                                        pr: '2px',
                                                    }}
                                                    // className="corner-value"
                                                >
                                                    <strong>Last Updated: </strong>
                                                    {moment(entity.lastUpdatedTime).format('DD-MM-YYYY')}

                                                    {/* {(Date(entity.lastUpdatedTime).toLocaleString()
                                                        .toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" })).substring(0, 25)} */}
                                                </Box>
                                            </Stack>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                            {(entities?.length === 0) &&
                                <NoRecordsFound message={"No project has been created yet."}/>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            )
            }
            {
                (totalPages > 1) &&
                <Pagination variant="outlined" color="primary" count={totalPages} page={pageFilter.pageNumber} onChange={navigatePage} />
            }

        </Box >
    );
}
